import PaymentMethods from 'pages/account/payment-methods';

export default function AccountPaymentPage() {
  return <PaymentMethods />;
}
